import { DayOfWeek } from '../../c-types/day-of-week.enum';

export enum DaysOfWeek {
  None = 0,
  Sunday = 1 << DayOfWeek.Sunday,
  Monday = 1 << DayOfWeek.Monday,
  Tuesday = 1 << DayOfWeek.Tuesday,
  Wednesday = 1 << DayOfWeek.Wednesday,
  Thursday = 1 << DayOfWeek.Thursday,
  Friday = 1 << DayOfWeek.Friday,
  Saturday = 1 << DayOfWeek.Saturday,

  AllDays = Sunday | Monday | Tuesday | Wednesday | Thursday | Friday | Saturday,
  WeekDays = Monday | Tuesday | Wednesday | Thursday | Friday,
  WeekEnd = Saturday | Sunday,
  M2W = Monday | Tuesday | Wednesday,
  M2Th = Monday | Tuesday | Wednesday | Thursday,
  M2F = Monday | Tuesday | Wednesday | Thursday | Friday,
  M2SA = Monday | Tuesday | Wednesday | Thursday | Friday | Saturday,
  Tu2Th = Tuesday | Wednesday | Thursday,
  Tu2F = Tuesday | Wednesday | Thursday | Friday,
  Tu2Sa = Tuesday | Wednesday | Thursday | Friday | Saturday,
  Tu2Su = Tuesday | Wednesday | Thursday | Friday | Saturday | Sunday,
  We2F = Wednesday | Thursday | Friday,
  We2Sa = Wednesday | Thursday | Friday | Saturday,
  We2Su = Wednesday | Thursday | Friday | Saturday | Sunday,
  Th2Sa = Thursday | Friday | Saturday,
  Th2Su = Thursday | Friday | Saturday | Sunday,
  Fr2Su = Friday | Saturday | Sunday,
  Sa2Th = Saturday | Sunday | Monday | Tuesday | Wednesday | Thursday,
  Su2Th = Sunday | Monday | Tuesday | Wednesday | Thursday,
  Su2F = Sunday | Monday | Tuesday | Wednesday | Thursday | Friday
}

export const DayOfWeekToBitMapping: Record<DayOfWeek, DaysOfWeek> = {
  [DayOfWeek.Sunday]: DaysOfWeek.Sunday,
  [DayOfWeek.Monday]: DaysOfWeek.Monday,
  [DayOfWeek.Tuesday]: DaysOfWeek.Tuesday,
  [DayOfWeek.Wednesday]: DaysOfWeek.Wednesday,
  [DayOfWeek.Thursday]: DaysOfWeek.Thursday,
  [DayOfWeek.Friday]: DaysOfWeek.Friday,
  [DayOfWeek.Saturday]: DaysOfWeek.Saturday
};

export const BitToDayOfWeekMapping: Record<DaysOfWeek, DayOfWeek> = {
  [DaysOfWeek.Sunday]: DayOfWeek.Sunday,
  [DaysOfWeek.Monday]: DayOfWeek.Monday,
  [DaysOfWeek.Tuesday]: DayOfWeek.Tuesday,
  [DaysOfWeek.Wednesday]: DayOfWeek.Wednesday,
  [DaysOfWeek.Thursday]: DayOfWeek.Thursday,
  [DaysOfWeek.Friday]: DayOfWeek.Friday,
  [DaysOfWeek.Saturday]: DayOfWeek.Saturday,
  [DaysOfWeek.None]: DayOfWeek.Sunday,
  [DaysOfWeek.AllDays]: DayOfWeek.Sunday,
  [DaysOfWeek.WeekDays]: DayOfWeek.Monday,
  [DaysOfWeek.WeekEnd]: DayOfWeek.Sunday,
  [DaysOfWeek.M2W]: DayOfWeek.Monday,
  [DaysOfWeek.M2Th]: DayOfWeek.Monday,
  [DaysOfWeek.M2SA]: DayOfWeek.Monday,
  [DaysOfWeek.Tu2F]: DayOfWeek.Tuesday,
  [DaysOfWeek.Tu2Sa]: DayOfWeek.Tuesday,
  [DaysOfWeek.Tu2Su]: DayOfWeek.Tuesday,
  [DaysOfWeek.We2F]: DayOfWeek.Wednesday,
  [DaysOfWeek.We2Sa]: DayOfWeek.Wednesday,
  [DaysOfWeek.We2Su]: DayOfWeek.Wednesday,
  [DaysOfWeek.Th2Sa]: DayOfWeek.Thursday,
  [DaysOfWeek.Th2Su]: DayOfWeek.Thursday,
  [DaysOfWeek.Fr2Su]: DayOfWeek.Friday,
  [DaysOfWeek.Su2Th]: DayOfWeek.Sunday,
  [DaysOfWeek.Su2F]: DayOfWeek.Sunday,
  [DaysOfWeek.Sa2Th]: DayOfWeek.Saturday,
  [DaysOfWeek.Tu2Th]: DayOfWeek.Tuesday
};

export function DaysOfWeekToString(days: DaysOfWeek): string {
  switch (days) {
    case DaysOfWeek.AllDays:
      return 'Every Day';
    case DaysOfWeek.WeekDays:
      return 'Week Days';
    case DaysOfWeek.WeekEnd:
      return 'Weekends';
    case DaysOfWeek.None:
      return 'Never';
    default: {
      const response: string[] = [];
      if (days & DaysOfWeek.Sunday) response.push('Su');
      if (days & DaysOfWeek.Monday) response.push('M');
      if (days & DaysOfWeek.Tuesday) response.push('Tu');
      if (days & DaysOfWeek.Wednesday) response.push('W');
      if (days & DaysOfWeek.Thursday) response.push('Th');
      if (days & DaysOfWeek.Friday) response.push('F');
      if (days & DaysOfWeek.Saturday) response.push('Sa');
      return response.join('');
    }
  }
}

export function DaysOfWeekToAbbrString(days: DaysOfWeek): string {
  switch (days) {
    case DaysOfWeek.AllDays:
      return 'Any';
    case DaysOfWeek.WeekDays:
      return 'WDays';
    case DaysOfWeek.WeekEnd:
      return 'WEnds';
    case DaysOfWeek.None:
      return '-';
    case DaysOfWeek.M2W: {
      return 'M-W';
    }
    case DaysOfWeek.M2Th: {
      return 'M-Th';
    }
    case DaysOfWeek.M2F: {
      return 'M-F';
    }
    case DaysOfWeek.M2SA: {
      return 'M-Sa';
    }
    case DaysOfWeek.Tu2F: {
      return 'Tu-F';
    }
    case DaysOfWeek.Tu2Sa: {
      return 'Tu-Sa';
    }
    case DaysOfWeek.Tu2Su: {
      return 'Tu-Su';
    }
    case DaysOfWeek.We2F: {
      return 'W-F';
    }
    case DaysOfWeek.We2Sa: {
      return 'W-Sa';
    }
    case DaysOfWeek.We2Su: {
      return 'W-Su';
    }
    case DaysOfWeek.Th2Sa: {
      return 'Th-Sa';
    }
    case DaysOfWeek.Th2Su: {
      return 'Th-Su';
    }
    case DaysOfWeek.Fr2Su: {
      return 'F-Su';
    }
    case DaysOfWeek.Sa2Th: {
      return 'Sa-Th';
    }
    case DaysOfWeek.Su2Th: {
      return 'Su-Th';
    }
    case DaysOfWeek.Su2F: {
      return 'Su-F';
    }
    default: {
      const response: string[] = [];
      if (days & DaysOfWeek.Sunday) response.push('Su');
      if (days & DaysOfWeek.Monday) response.push('M');
      if (days & DaysOfWeek.Tuesday) response.push('Tu');
      if (days & DaysOfWeek.Wednesday) response.push('W');
      if (days & DaysOfWeek.Thursday) response.push('Th');
      if (days & DaysOfWeek.Friday) response.push('F');
      if (days & DaysOfWeek.Saturday) response.push('Sa');
      return response.join('');
    }
  }
}
